// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"55":"90cd2d0f","263":"90cd2d0f","702":"8c622c1a","744":"90cd2d0f"}[chunkId] + ".chunk.css";
};